//import axios from "#/plugins/Axios"
import _ from "lodash"
import Vue from "vue"
import router from '#/router'
import store from '#/store'
import VueCookies from 'vue-cookies'
import vuetify from "#/plugins/Vuetify"

// App Config
store.dispatch('config/load')

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

import GSignInButton from 'vue-google-signin-button'
Vue.use(GSignInButton)

Vue.component('App', require('./components/App.vue').default);

Vue.use(VueCookies)

var user = Vue.$cookies.get('user')
if(user) {
    store.dispatch('user/storeUser', user)
}
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 *
 * Also: Check whether the view have the #app selector.
 */

//if (document.querySelector("#app") !== null) {
    export const app = new Vue({
        el: '#app',
        router,
        store,
        vuetify,
    });
//}
